import { get } from "@u/request";
import request from '@/utils/request'

// 获取系科资源列表
export function getDepartmentList() {
  return get('/lib/department/list')
}

// 获取专题资源列表
export function getSpecialList() {
  return get('/lib/special/list')

}

export function getListByDepartmentResource(id,lang) {//根据系科资源ID查询图书推荐

  return get(`/portal/bookRecommend/listByDepartmentResource/${id}?bookType=${lang}`)

}
export function getListBySpecialResource(id,lang) {//根据专科专题ID查询图书推荐

  return get(`/portal/bookRecommend/listBySpecialResource/${id}?bookType=${lang}`)

}
export function getListByDepartmentResourceJournal(id,lang) {//根据系科资源ID查询期刊

  return get(`/portal/journalRecommend/listByDepartmentResource/${id}?journalType=${lang}`)

}
export function getListBySpecialResourceJournal(id,lang) {//根据专科专题ID查询期刊

  return get(`/portal/journalRecommend/listBySpecialResource/${id}?journalType=${lang}`)

}

export function getListByDepartmentResourceElectronicl(id) {//根据系科资源ID查询电子资源
  console.log(id,373737)

  return get(`/portal/electronicResourceRecommend/listByDepartmentResource/${id}`)

}
export function getListBySpecialResourceElectronic(id) {//根据专科专题ID查询电子资源
  console.log(id,373737)

  return get(`/portal/electronicResourceRecommend/listBySpecialResource/${id}`)

}

export function getListByDepartmentResourceScholarRecommend(id) {//根据系科资源ID查询学者
  console.log(id,50)

  return get(`/portal/scholarRecommend/listByDepartmentResource/${id}`)

}
export function getListBySpecialResourceScholarRecommend(id) {//根据专科专题ID查询学者
  console.log(id,56)

  return get(`/portal/scholarRecommend/listBySpecialResource/${id}`)

}


export function getModelSorted() {//模块排序

  return get(`/portal/bookRecommend/subjectType/list`)

}